export const sidebar = {
  background: {
    color: '#172331'
  },
  box: {
    shadow: 'inset 0 -10px 0 0 #1a2b3d'
  },
  height: 'var(--app-height)',
  width: '298px',
  zindex: 10,
  divider: {
    color: '#24364b'
  },

  header: {
    border: {
      bottom: '1px solid var(--sidebar-divider-color)'
    },
    height: '110px',
    image: {
      background: {
        _: 'url(https://opensense.s3.amazonaws.com/logo-horizontal-white-colored-emblem.svg) no-repeat center center',
        size: '185px 44px'
      },
      height: '44px',
      width: '185px'
    },
    margin: '0 var(--margin-xlarge)',
    padding: 'var(--padding-xxlarge) 0',

    badge: {
      backgroundColor: '#314558',
      borderRadius: '20px',
      color: 'var(--color-white)',
      font: {
        size: 'var(--font-size-xsmall)',
        weight: 'var(--font-weight-base)'
      },
      left: 'calc(50% - calc(var(--sidebar-header-badge-width) / 2))',
      padding: 'var(--padding-small) var(--padding-base)',
      height: '15px',
      width: '56px',
      zindex: 12
    }
  },

  section: {
    heading: {
      color: {
        _: '#505d71',
        hover: 'var(--color-white)',
        active: 'var(--color-white)'
      },
      toggle: {
        icon: {
          color: {
            active: 'var(--color-white)'
          }
        }
      },
      icon: {
        background: {
          color: {
            active: 'var(--color-blue-400)'
          }
        },
        color: {
          _: 'var(--color-white)',
          active: 'var(--color-white)'
        }
      }
    },
    items: {
      border: {
        left: '2px solid #24364b'
      },
      active: {
        item: {
          color: 'var(--sidebar-section-item-color-active)'
        }
      }
    },
    item: {
      backgroundColor: {
        active: 'var(--color-blue-400)',
        hover: '#24364b'
      },
      borderRadius: 'var(--border-radius-base)',
      color: {
        _: 'var(--color-gray-800)',
        hover: 'var(--color-white)',
        active: 'var(--color-white)'
      },
      fontSize: 'var(--font-size-base)'
    }
  },
  user: {
    background: {
      color: '#1a2b3d'
    },

    name: {
      color: 'var(--color-white)',
      fontSize: 'var(--font-size-base)',
      fontWeight: 'var(--font-weight-medium)'
    },

    company: {
      color: 'var(--color-gray-600)',
      fontSize: 'var(--font-size-medium)'
    },

    trigger: {
      backgroundColor: '#233548',
      borderRadius: 'var(--border-radius-base)',
      color: 'var(--color-gray-600)'
    }
  },
  collpased: {
    width: '101px',
    header: {
      image: {
        background: {
          _: 'url(https://opensense.s3.amazonaws.com/logo-emblem.svg) no-repeat center center',
          size: '46px 44px'
        },
        height: '44px',
        width: '46px'
      }
    }
  }
};
